import React from 'react'
import { useForm } from 'react-hook-form'

export default function ConfirmProviderSplitModal({
  changes,
  saving,
  onConfirm,
  onClose,
}) {
  const { register, handleSubmit } = useForm({ defaultValues: { reason: '' } })

  return (
    <div className="modal is-active" data-testid="confirm-provider-split-modal">
      <div className="modal-background" />
      <div className="modal-card">
        <header className="modal-card-head has-background-link">
          <p className="modal-card-title has-text-white">
            Confirm provider split changes
          </p>
        </header>
        <section className="modal-card-body">
          <p className="mb-3">
            New bank verifications will use these splits as soon as you save.
            Verifications already in progress are not affected.
          </p>
          <table className="table is-fullwidth is-narrow">
            <thead>
              <tr>
                <th>Table</th>
                <th>Portfolio</th>
                <th>Provider</th>
                <th className="has-text-right">Change</th>
              </tr>
            </thead>
            <tbody>
              {changes.map((change) => (
                <tr
                  key={change.key}
                  data-testid="confirm-provider-split-modal-change-row"
                >
                  <td>{change.typeLabel}</td>
                  <td>{change.portfolioName}</td>
                  <td>
                    <strong>{change.providerLabel}</strong>
                  </td>
                  <td className="has-text-right">
                    <s>{change.before}%</s> → <strong>{change.after}%</strong>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <label className="label" htmlFor="provider-split-reason">
            Reason for change (optional, saved to audit log)
          </label>
          <textarea
            id="provider-split-reason"
            className="textarea"
            maxLength={255}
            placeholder="e.g. Shifting SSV volume to Chirp for Q4 test"
            data-testid="confirm-provider-split-modal-reason"
            {...register('reason')}
          />
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button
              type="button"
              className="button is-small has-background-grey has-text-white"
              onClick={onClose}
              disabled={saving}
              data-testid="confirm-provider-split-modal-go-back"
            >
              Go back
            </button>
            <button
              type="button"
              className="button is-link is-small"
              onClick={handleSubmit(({ reason }) => onConfirm(reason))}
              disabled={saving}
              data-testid="confirm-provider-split-modal-confirm"
            >
              {saving ? 'Saving' : 'Confirm & save'}
            </button>
          </div>
        </footer>
      </div>
    </div>
  )
}
